/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { LuMail } from 'react-icons/lu';
import { openDialog } from '../../../../app/dialog/dialog.actions';
import { updateMeetingSimple } from '../../../../app/page/page-storage/meetings-simple/meetings-simple.actions';
import { meetingSimpleSelectors } from '../../../../app/resource/meeting-simple/meeting-simple.selectors';
import { IMeetingSimpleUpdate } from '../../../../app/resource/meeting-simple/meeting-simple.types';
import { IMeetingParticipantsUpdateForm } from '../../../../app/resource/meeting/meeting.types';
import { useSelect, useSelectWithParams } from '../../../../utils/selector.utils';
import { ParticipantList } from './ParticipantList';
import { IMeetingParticipantsProps } from './types';
import {
  updateMeetingParticipants,
  sendMessageToMeetingMembers,
} from '../../../../app/page/page-storage/meetings-simple/meetings-simple.actions';
import { isMemberAnAdmin } from '../../../../utils/user.utils';
import { IUser } from '../../../../app/resource/user/user.types';
import { authSelectors } from '../../../../app/auth/auth.selectors';
import { userSelectors } from '../../../../app/resource/user/user.selectors';

export const MeetingParticipants: FunctionComponent<IMeetingParticipantsProps> = ({ meetingId }) => {
  const loggedUserId = useSelect(authSelectors.selectLoggedUser) as IUser['id'];
  const loggedUser = useSelectWithParams(userSelectors.selectResourceById, loggedUserId) as IUser;

  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);

  const [reorder, setReorder] = useState(false);
  const [adminIds, setAdminIds] = useState(meeting ? meeting.administratorIds : []);
  const [shareWithIds, setShareWithIds] = useState(meeting ? meeting.shareWithIds : []);

  useEffect(() => {
    if (meeting) {
      setAdminIds(meeting.administratorIds);
      setShareWithIds(meeting.shareWithIds);
    }
  }, [meeting, meetingId]);
  const handleAdminIds = useCallback((userIds) => {
    setAdminIds(userIds);
  }, []);
  const handleShareWithIds = useCallback((userIds) => {
    setShareWithIds(userIds);
  }, []);

  const dispatch = useDispatch();

  const openMeetingForm = useCallback(() => {
    if (meeting) {
      dispatch(
        openDialog('meetingFormDialog', {
          type: meeting.type,
          data: meeting,
          onSubmit: (meetingInfo: IMeetingSimpleUpdate) => {
            dispatch(
              updateMeetingSimple(meeting.id, {
                ...meetingInfo,
                type: meeting.type,
              }),
            );
          },
        }),
      );
    }
  }, [dispatch, meeting]);

  const openSendMessageDialog = useCallback(() => {
    if (meeting) {
      dispatch(
        openDialog('sendMessageToMembersDialog', {
          meetingId: meeting.id,
          onSend: (message: string, memberIds: string[]) => {
            dispatch(sendMessageToMeetingMembers(loggedUserId, memberIds, meeting.id, message));
          },
        }),
      );
    }
  }, [dispatch, meeting, loggedUserId]);

  const handleReorder = useCallback(() => {
    setReorder(!reorder);
  }, [reorder]);

  const handleSaveOrder = useCallback(() => {
    setReorder(false);
    if (!!meeting) {
      const updatedMeetingParticipants = {
        administrators: adminIds,
        shareWith: shareWithIds,
      } as IMeetingParticipantsUpdateForm;

      dispatch(updateMeetingParticipants(meetingId, updatedMeetingParticipants));
    }
  }, [adminIds, dispatch, meeting, meetingId, shareWithIds]);

  return (
    meeting && (
      <div className="panel vto-text h100 flex flex-column">
        <div className="panel-header no-border">
          <h2 className="bold">Meeting Members</h2>
          <div className="ml-auto flex aic">
            {isMemberAnAdmin(loggedUser, meeting) && (
              <>
                <a className="btn btn-md popup_button" title="Send Message" onClick={openSendMessageDialog}>
                  <LuMail className="mr-1" /> Message Members
                </a>
                <a className="btn btn-md popup_button" title="Edit Meeting" onClick={openMeetingForm}>
                  <i className="icon-plus" /> Edit Meeting
                </a>
                {!reorder ? (
                  <a className="btn btn-md popup_button" title="Reorder" onClick={handleReorder}>
                    <img
                      src={require('../../../resources/images/reorder.png')}
                      className="mr-1"
                      alt="img"
                      style={{ width: '20px' }}
                    />{' '}
                    Reorder
                  </a>
                ) : (
                  <a className="btn btn-md popup_button" title="Save Order" onClick={handleSaveOrder}>
                    <img
                      src={require('../../../resources/images/reorder.png')}
                      className="mr-1"
                      alt="img"
                      style={{ width: '20px' }}
                    />{' '}
                    Save
                  </a>
                )}
              </>
            )}
          </div>
        </div>
        <div className="row h100">
          <div className="col-12">
            <div className="panel-body pt-0 h100">
              <div className="border-radius-1 lightGray-bg p-2 h100">
                <div className="panel py-1 px-0 mb-1 no-border">
                  <div className="panel-body pt-05 h100">
                    <h5 className="bold">{meeting.type === 'account' ? 'ATAK Interactive' : 'ADMINS'}</h5>
                  </div>
                  <ParticipantList
                    userIds={adminIds}
                    handleUserIds={handleAdminIds}
                    meetingId={meeting.id}
                    reorder={reorder}
                  />
                </div>

                <div className="panel py-1 px-0 mb-0 no-border" style={{ marginBottom: '-10px !important' }}>
                  <div className="panel-body pt-05 h100">
                    <h5 className="bold">{meeting.type === 'account' ? meeting.title : 'MEMBERS'}</h5>
                  </div>
                  <ParticipantList
                    userIds={shareWithIds}
                    handleUserIds={handleShareWithIds}
                    meetingId={meeting.id}
                    reorder={reorder}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
